import React from 'react';
import KBTooltipWrapper from './TooltipWrapper';

export default function InterfaceButton({
    onClick, content, tooltip
}) {
    return (
        <KBTooltipWrapper tooltipText={tooltip}>
            <button
                onClick={onClick}
                className="p-2 hover:bg-accent rounded-md text-muted-foreground hover:text-foreground transition-colors"
                type="button"
            >
                {content}
            </button>
        </KBTooltipWrapper>
    );
}
